/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type { SoundingsModuleState } from './types';

type SoundingsStateLike = SoundingsModuleState['soundings'];
const emptyViewIds: string[] = [];

const toStringArray = (value: unknown): string[] => {
  if (!Array.isArray(value)) {
    return emptyViewIds;
  }
  return value.filter((item): item is string => typeof item === 'string');
};

export const getRegisteredViewIds = (
  state: SoundingsStateLike | undefined,
): string[] => {
  if (!state) {
    return emptyViewIds;
  }
  const registeredSoundingsViewIds = toStringArray(
    state.registeredSoundingsViewIds,
  );
  if (registeredSoundingsViewIds.length > 0) {
    return registeredSoundingsViewIds;
  }
  return Object.keys(state.byId);
};

export const isRegisteredViewId = (
  state: SoundingsStateLike | undefined,
  viewId?: string,
): boolean => {
  if (!viewId) {
    return false;
  }
  return getRegisteredViewIds(state).includes(viewId);
};

export const getViewIdFromAction = (action: {
  payload?: { viewId?: string };
}): string | undefined => action.payload?.viewId;
